export enum OperatingSystem {
  WINDOWS = 'windows',
  MACOS = 'macOs',
  LINUX = 'linux',
  CHROMEOS = 'chromeOs',
  ANDROID = 'android',
  IOS = 'ios',
  BLACKBERRY = 'blackBerry',
  WEBOS = 'webos',
  UNKNOWN = 'Unknown',
}

export default interface IDeviceInfo {
  os: OperatingSystem
  isMobile: boolean
}
